var map = {
	"./about-us-banner.webp": 219,
	"./anniversary-banner-bm.webp": 1589,
	"./anniversary-banner-cn.webp": 1590,
	"./anniversary-banner-id.webp": 1591,
	"./anniversary-banner.webp": 1592,
	"./banner-01.jpg": 1593,
	"./banner-slot.jpg": 1594,
	"./bet-and-earn-banner-cn.webp": 1595,
	"./bet-and-earn-banner-indon.webp": 1596,
	"./bet-and-earn-banner-ms.webp": 1597,
	"./bet-and-earn-banner.webp": 1598,
	"./check-in-banner-cn.webp": 1599,
	"./check-in-banner-id.webp": 1600,
	"./check-in-banner-ms.webp": 1601,
	"./check-in-banner.webp": 1602,
	"./cny_2024-bm.webp": 1603,
	"./cny_2024-cn.webp": 1604,
	"./cny_2024.webp": 1605,
	"./epl-banner-cn.jpg": 1606,
	"./epl-banner-cn.webp": 1607,
	"./epl-banner-indo.jpg": 1608,
	"./epl-banner-indo.webp": 1609,
	"./epl-banner-ms.jpg": 1610,
	"./epl-banner-ms.webp": 1611,
	"./epl-banner.jpg": 1612,
	"./epl-banner.webp": 1613,
	"./games-banner-cn.webp": 1614,
	"./games-banner-id.webp": 1615,
	"./games-banner-ms.webp": 1616,
	"./games-banner.webp": 1617,
	"./lb-m-banner-cn.webp": 1618,
	"./lb-m-banner.webp": 1619,
	"./leaderboard-banner-cn.webp": 1620,
	"./leaderboard-banner.webp": 1621,
	"./lottery-banner.webp": 1622,
	"./lottery-banners-cn.webp": 1623,
	"./lottery-banners-id.webp": 1624,
	"./lottery-banners-ms.webp": 1625,
	"./lottery-banners.webp": 1626,
	"./lucky-spin-banner-cn.webp": 1627,
	"./lucky-spin-banner-ms.webp": 1628,
	"./lucky-spin-banner-vn.webp": 1629,
	"./lucky-spin-banner.webp": 1630,
	"./p2p-banner.webp": 1631,
	"./p2p-banners-cn.webp": 1632,
	"./p2p-banners-id.webp": 1633,
	"./p2p-banners-ms.webp": 1634,
	"./p2p-banners.webp": 1635,
	"./premier-league-banner-cn.webp": 1636,
	"./premier-league-banner.webp": 1637,
	"./promos-banner-cn.webp": 1638,
	"./promos-banner-indon.webp": 1639,
	"./promos-banner-ms.webp": 1640,
	"./promos-banner.webp": 1641,
	"./promos-detail-banner.jpg": 1642,
	"./side-bar-banner.jpg": 1643,
	"./slot-banners-cn.webp": 1644,
	"./slot-banners-ms.webp": 1645,
	"./slot-banners.webp": 1646,
	"./speed-banners-cn.webp": 1647,
	"./speed-banners-ms.webp": 1648,
	"./speed-banners.webp": 1649,
	"./uefa24-prediction-bm.webp": 1650,
	"./uefa24-prediction-cn.webp": 1651,
	"./uefa24-prediction-id.webp": 1652,
	"./uefa24-prediction.webp": 1653,
	"./vip-banner-cn.webp": 1654,
	"./vip-banner-id.webp": 1655,
	"./vip-banner-ms.webp": 1656,
	"./vip-banner-vn.webp": 1657,
	"./vip-banner.webp": 1658,
	"./winner-leaderboard-banner-cn.webp": 1659,
	"./winner-leaderboard-banner.webp": 1660,
	"./world-cup-banner-cn.webp": 1661,
	"./world-cup-banner.webp": 1662,
	"./world-cup-two-banner-cn.webp": 1663,
	"./world-cup-two-banner.webp": 1664,
	"./xmas_2023-bm.jpg": 1665,
	"./xmas_2023-cn.jpg": 1666,
	"./xmas_2023-id.jpg": 1667,
	"./xmas_2023.jpg": 1668,
	"./xmas_2024-bm.webp": 1669,
	"./xmas_2024-cn.webp": 1670,
	"./xmas_2024.webp": 1671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;